import { Button, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { capturePHEvents } from '../../../../analytics/posthog.analytics';
import AddOrUpdateAssignment from '../../../../components/AddOrUpdateAssignment';
import { teacherTestBar } from '../../../../utils/constants';
import CustomizeTabs from '../../../../components/CustomizeTabs';
import UpcomingAsgnList from '../Assignment/Teacher.UpcomingAsgnList';
import PreviousAsgnList from '../Assignment/Teacher.PreviousAsgnList';
import { PH_ADD_ASSIGNMENT_CLICK } from '../../../../utils/posthog.eventNames';

export default function TeacherAssignments({ classId }) {
  const [value, setValue] = useState(0);
  const [openDialog, setDialog] = useState(false);
  const [assignmentSelected, setAssignmentSelected] = useState(false);
  const upcomingAsgnRef = useRef();
  const previousAsgnRef = useRef();
  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const refreshData = () => {
    if (value === 0 && upcomingAsgnRef.current) upcomingAsgnRef.current.refreshData();
    if (value === 1 && previousAsgnRef.current) previousAsgnRef.current.refreshData();
  };
  return (
    <div style={{ marginTop: 15 }}>
      {!assignmentSelected && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          alignItems={{ sm: 'center' }}
          justifyContent={{ sm: 'space-between' }}
          mb={5}
        >
          <CustomizeTabs value={value} options={teacherTestBar} onChange={(v) => handleChange(v)} />
          <Button
            variant="contained"
            style={{ height: 'fit-content' }}
            onClick={() => {
              capturePHEvents(PH_ADD_ASSIGNMENT_CLICK, { classId });
              setDialog(true);
            }}
          >
            + New Assignment
          </Button>
        </Stack>
      )}
      {value === 0 && (
        <UpcomingAsgnList
          ref={upcomingAsgnRef}
          handleAsgnSelected={(v) => setAssignmentSelected(v)}
        />
      )}
      {value === 1 && (
        <PreviousAsgnList
          ref={previousAsgnRef}
          handleAsgnSelected={(v) => setAssignmentSelected(v)}
        />
      )}
      <AddOrUpdateAssignment
        open={openDialog}
        onClose={() => {
          setDialog(false);
          refreshData();
        }}
      />
    </div>
  );
}

TeacherAssignments.propTypes = {
  classId: PropTypes.string
};
